export default "__VITE_ASSET__C0B8En$s__"